import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { AbstractUrgencyService } from 'src/app/core/services/abstract/abstract-urgency-api-service';
import * as actions from './actions';

@Injectable()
export class UrgencyStoreEffects {
  private urgencyService = inject(AbstractUrgencyService);
  private actions$ = inject(Actions);

  loadRequestEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.LoadRequestAction>(actions.ActionTypes.LOAD_REQUEST),
      //startWith(new actions.LoadRequestAction()),
      switchMap(action =>
        this.urgencyService.getAll().pipe(
          map(items => (items.isSucceeded ? new actions.LoadSuccessAction(items.result) : new actions.FailureAction(items.errors[0]))),
          catchError(error => observableOf(new actions.FailureAction(error)))
        )
      )
    )
  );
}
